module.exports = __webpack_public_path__ + "img/dumbbell-solid.2cda412a.svg";